import React from "react";
import { KeyboardDatePicker } from "@material-ui/pickers";

export default ({
    onChange,
    value,
    label,
    style
}) => {

    return (
        <KeyboardDatePicker
            fullWidth
            style={style}
            inputVariant="outlined"
            autoOk
            margin="normal"
            label={label}
            format="dd/MM/yyyy"
            value={value}
            onChange={(e) => {
                onChange(e);
            }}
            KeyboardButtonProps={{
            "aria-label": "change date",
            }}
      />
    );
}